module.exports = __webpack_public_path__ + "static/img/hero-bg.fb3889e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero-bg.png
// module id = 45Wh
// module chunks = 1